export const Brand = ({ dark = false, className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <span className="grid h-8 w-8 place-items-center rounded-lg bg-[#2563EB] shadow-[0_6px_20px_-6px_rgba(37,99,235,.8)]">
      <svg viewBox="0 0 32 32" className="h-5 w-5">
        <path d="M8 7l8 10 8-10M16 17v8" stroke="white" strokeWidth="3.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
    <span className={`font-display text-xl font-bold tracking-tight ${dark ? "text-white" : "text-[#0A1F44]"}`}>
      YesPay<span className="text-[#2563EB]">Bizz</span>
    </span>
  </div>
);
